import { UtilityProgram } from '@/types/utilityProgram'
import { useParams } from 'react-router-dom'
import { ChevronRight } from 'react-feather'
import { Text, Tag } from '@/components'
import { useDeviceVerificationStatus } from '@/hooks/useDeviceVerificationStatus/useDeviceVerificationStatus'
import UtilityProgramHelpers from '@/utils/utility-program-helpers/utilityProgramHelpers'
import { deviceTypeFromUrlSlug } from '@/app/components/DeviceSelectionGallery/DeviceSelectionGallery.utils'
import { DeviceUrlSlug } from '@/app/components/DeviceSelectionGallery/DeviceSelectionGallery.types'
import { useCurrentMultiProgramFlowContext } from '@/app/context/MultiProgram/MultiProgramFlowContexts'

type Props = {
  program: UtilityProgram
}

export default function ProgramApplicationCard(props: Props) {
  const { program } = props
  const { deviceId, deviceType } = useParams<{
    deviceId?: string
    deviceType?: DeviceUrlSlug
  }>()

  const { deviceStatus } = useDeviceVerificationStatus({
    programId: program.id,
    deviceId: deviceId,
    deviceType: deviceType ? deviceTypeFromUrlSlug(deviceType) : undefined,
  })

  const { onProgramCardClicked } = useCurrentMultiProgramFlowContext()

  const formattedStatusInfo =
    UtilityProgramHelpers.verificationStatusToDisplay(deviceStatus)

  const sponsorImg =
    program?.view_config_json?.logoUrl ?? program.logo_url ?? null
  const programName = program.view_config_json?.name ?? program.name

  const handleClick = () => {
    if (onProgramCardClicked) {
      onProgramCardClicked(program, true)
    }
  }

  return (
    <div
      className="bg-base-white rounded-2xl p-4 flex items-center gap-4 cursor-pointer hover:bg-base-grey-50 transition-colors"
      onClick={handleClick}
    >
      {sponsorImg && (
        <img
          src={sponsorImg}
          alt="Program Sponsor"
          className="w-16 h-16 object-contain flex-shrink-0"
        />
      )}
      <div className="flex-1 min-w-0 flex flex-col md:flex-row md:items-center md:justify-between gap-2 md:gap-3">
        <Text variant="body1" className="text-base-grey-900">
          {programName}
        </Text>
        {formattedStatusInfo.visible && (
          <Tag color={formattedStatusInfo.bgColor} className="rounded-xl w-fit">
            <div
              className={`font-bold text-[12px] ${formattedStatusInfo.color}`}
            >
              {formattedStatusInfo.text}
            </div>
          </Tag>
        )}
      </div>
      <ChevronRight size={20} className="text-base-grey-400 flex-shrink-0" />
    </div>
  )
}
